import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { checkAuth } from '../redux/actions';

export default function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    dispatch(checkAuth.setCurrentPage('login'));
    return () => {
      dispatch(checkAuth.setCurrentPage('public'));
    };
  }, [dispatch]);

  const login = (e) => {
    e.preventDefault();
    const username = e.target.elements.username.value;
    const password = e.target.elements.password.value;
    if (username === 'administrator' && password === '123456789x@XX') {
      setErrorMessage('');
      dispatch(checkAuth.login({ username, password }));
      history.push('/admin/dashboard/posts');
    } else {
      setErrorMessage('Username or Password is invalid!');
    }
  };

  return (
    <div style={{ height: '100vh', backgroundColor: '#ccc' }}
      className="d-flex flex-column justify-content-center align-items-center">
      <div className="login-message">{errorMessage}</div>
      <form onSubmit={login} className="login">
        <div className="login-header">Login</div>
        <div className="login-body">
          <div className="input-group input-group-sm w-auto mb-3">
            <span className="input-group-text">Username</span>
            <input id="username" type="text" className="form-control" required />
          </div>
          <div className="input-group input-group-sm w-auto mb-3">
            <span className="input-group-text">Password</span>
            <input id="password" type="password" className="form-control" required />
          </div>
          <button className="btn btn-primary mt-3">Login</button>
        </div>
      </form>
    </div>
  )
}